import { jsx as _jsx } from "react/jsx-runtime";
import { createChildren } from './createChildren';
import { getContainerStyles } from './getContainerStyles';
import { selectLayoutState, selectBirdElementsState, selectAccessibilityLabelState, } from '../../store/selectors';
import { connect } from 'react-redux';
export const BoxBase = function (props) {
    var _a;
    const accessibilityLabel = ((_a = props.elementState.Container[props.id]) === null || _a === void 0 ? void 0 : _a.isComposite)
        ? props.accessibilityLabel
        : undefined;
    return (_jsx("div", Object.assign({ "aria-label": accessibilityLabel, style: getContainerStyles(props.layoutState) }, { children: createChildren(props.layoutState.childKeys, props.elementState) })));
};
export const Box = connect((state, props) => ({
    layoutState: selectLayoutState(state, props.id),
    elementState: selectBirdElementsState(state),
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}))(BoxBase);
